import { render } from "./m_footer.vue?vue&type=template&id=5baa6724&scoped=true"
import script from "./m_footer.vue?vue&type=script&lang=js"
export * from "./m_footer.vue?vue&type=script&lang=js"

import "./m_footer.vue?vue&type=style&index=0&id=5baa6724&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baa6724"]])

export default __exports__